import { CurrErrProps } from './errorTypes';

export const isValidErrors = (errors: Array<CurrErrProps>) => {
  return Array.isArray(errors) && errors.length > 0;
};
